/* eslint-disable no-console */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-extraneous-dependencies */
// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect, useReducer } from 'react'
import { useParams } from 'react-router-dom'
import { Content, Toast, TableV2, Checkbox, Breadcrumbs, Button, Popup } from '@leverege/ui-elements'
import { Item } from '@leverege/ui-elements/lib/esm/Popup'
import { TitleBar } from '@leverege/ui-plugin'
import { push } from 'connected-react-router'
import { GlobalState } from '@leverege/ui-redux'
import { RoutesUtil as Util } from '@leverege/molten/routes'
import { getConsolidatedDeviceData, getUserName } from '../utils/interface'

const initialState = {
  selectedRows : [],
  hiddenColumns : 'targeted', // remove after implementation
}

const reducer = ( state, action ) => {
  switch ( action.type ) {
    // case 'SET_DATA':
    //   return { ...state, data : action.payload }
    // case 'SET_SHOW_DIALOG':
    //   return { ...state, showDialog : action.payload }
    // case 'SET_EDIT_DATA':
    //   return { ...state, editData : action.payload }
    // case 'SET_FIRMWARE_OPTIONS':
    //   return { ...state, firmwareOptions : action.payload }
    // case 'SET_SHOW_CONFIRMATION_DIALOG':
    //   return { ...state, showConfirmationDialog : action.payload }
    // case 'SET_SHOW_DELETE_DIALOG':
    //   return { ...state, showDeleteDialog : action.payload }
    // case 'SET_PREVIOUS_TARGET':
    //   return { ...state, previousTarget : action.payload }
    // case 'SET_ACTIVE_TAB':
    //   return { ...state, activeTab : action.payload }
    // case 'SET_IS_DIALOG_EXPANDED':
    //   return { ...state, isDialogExpanded : action.payload }
    // case 'SET_IS_EDIT_MODE':
    //   return { ...state, isEditMode : action.payload }
    case 'SET_SELECTED_ROWS':
      return { ...state, selectedRows : action.payload }
    // case 'CLEAR_SELECTED_ROWS':
    //   return { ...state, selectedRows : [] }
    default:
      return state
  }
}

function DevicesUnderUserScreen( props ) {
  const { match } = props
  const { userId } = useParams()
  const [ userEmail, setUserEmail ] = useState( '' )
  const [ deviceData, setDeviceData ] = useState( [] )
  const [ loading, setLoading ] = useState( false )

  const [ state, dispatch ] = useReducer( reducer, initialState )

  const rootPath = match ? Util.resolve( '/customers/', match ) : ''
  const overViewPath = match ? Util.resolve( '/customers/devicesUnderUser/:userId/', match ) : ''

  const onClickBreadCrumb = ( ctx ) => {
    const isRoot = ctx.data?.root
    GlobalState.dispatch( isRoot ? push( rootPath ) : push( overViewPath ) )
  }

  const handleNavigate = ( blueprintType, deviceId ) => { 
    GlobalState.dispatch( push( `/p/:persona/${blueprintType}/${deviceId}/` ) )
  }

  const handleAddNewRow = () => {
    // dispatch( {
    //   type : 'SET_EDIT_DATA',
    //   payload : {
    //     major : '',
    //     minor : '',
    //     target : '',
    //     targetId : '',
    //     tabId : state.activeTab.value
    //   }
    // } )
    // dispatch( { type : 'SET_SHOW_DIALOG', payload : true } )
    // dispatch( { type : 'SET_IS_EDIT_MODE', payload : false } )
  }

  useEffect( () => {
    const fetchDeviceData = async () => {
      if ( userId ) {
        setLoading( true )
        try {
          const userData = await getUserName( process.env.PROJECT_ID, userId )
          setUserEmail( userData.email )
          const data = await getConsolidatedDeviceData( userId, process.env.PROJECT_ID )
          setDeviceData( data )
        } catch ( error ) {
          console.error( 'Error fetching device data:', error )
          Toast.error( 'Error fetching device data' )
        }
        setLoading( false )
      }
    }

    fetchDeviceData()
  }, [ userId ] )

  const handleRowSelect = ( row ) => {
    const selectedRows = state.selectedRows.includes( row ) ?
      state.selectedRows.filter( r => r !== row ) :
      [ ...state.selectedRows, row ]
    if ( !dispatch ) {
      console.log( 'NO DISPATCH' )
    }
    dispatch( { type : 'SET_SELECTED_ROWS', payload : selectedRows } )
  }

  const columns = [
    {
      id : 'targeted',
      Header : '',
      width : 52,
      minWidth : 52,
      maxWidth : 52,
      Cell : ( { row } ) => (
        <Checkbox
          variant="small"
          eventData={row}
          value={state.selectedRows.includes( row.original )}
          onChange={() => handleRowSelect( row.original )}/>
      )
    },
    {
      Header : 'Name',
      accessor : 'name'
    },
    {
      Header : 'Blueprint Type',
      accessor : 'blueprintType'
    },
    {
      Header : 'ID',
      Cell : x => (
        <Button
          variant="linkTable" 
          onClick={() => handleNavigate( x.cell.row.original.blueprintType, x.cell.row.original.id )}>
          {x.cell.row.original.id}
        </Button>
      )
    },
    {
      Header : 'Roles',
      accessor : 'roles',
      Cell : RolesCell
    },
    {
      Header : 'Created',
      accessor : 'created'
    },
    {
      Header : 'Last Modified',
      accessor : 'lastModified'
    },
  ]

  const handleEdit = async () => {
    const data = state.selectedRows
    console.log( `${data?.length} rows selected` )
    // dispatch( { type : 'SET_EDIT_DATA', payload : { ...data, tabId : state.activeTab.value } } )
    // dispatch( { type : 'SET_SHOW_DIALOG', payload : true } )
    // dispatch( { type : 'SET_PREVIOUS_TARGET', payload : data.target } )
    // dispatch( { type : 'SET_IS_EDIT_MODE', payload : true } )
  }

  const handleDelete = async () => {
    const data = state.selectedRows
    console.log( `${data?.length} rows selected` )
    // dispatch( { type : 'SET_EDIT_DATA', payload : { ...data, tabId : state.activeTab.value } } )
    // dispatch( { type : 'SET_SHOW_DIALOG', payload : true } )
    // dispatch( { type : 'SET_PREVIOUS_TARGET', payload : data.target } )
    // dispatch( { type : 'SET_IS_EDIT_MODE', payload : true } )
  }

  return (
    <Content>
      <Breadcrumbs
        variant="topNavBreadcrumbs"
        onClick={onClickBreadCrumb}
        crumbs={[ 
          { name : 'Customers', root : true }, 
          { name : 'Devices Under user' }
        ]}/>
      <Content.Header>
        <TitleBar
          variant="screenTitle"
          title={`Devices Under ${userEmail}`}
          icon="fa-solid fa-users">
          {!initialState.hiddenColumns.includes( 'targeted' ) && ( // remove check after implementation
            <Popup
              open
              closeOnEscape
              closeOnDocumentClick
              iconOn="fa-solid fa-ellipsis-vertical"
              iconOff="fa-solid fa-ellipsis-vertical">
              <Popup.Header>
                Actions
              </Popup.Header>
              <Item
                icon="fa-light fa-plus"
                onClick={handleAddNewRow}>
                Add Device
              </Item>
              {state.selectedRows.length >= 1 && (
                <Item
                  icon="fa-light fa-edit"
                  onClick={handleEdit}>
                  Change Permissions on Selected Device(s)
                </Item>
              )}
              {state.selectedRows.length >= 1 && (
                <Item
                  icon="fa-light fa-trash"
                  onClick={handleDelete}>
                  Remove Selected Device(s)
                </Item>
              )}
            </Popup>
          )}
        </TitleBar>
      </Content.Header>
      <Content.Area>
        <TableV2
          variant="dataTable"
          data={deviceData}
          columns={columns}
          initialState={initialState}
          loading={loading}/>
      </Content.Area>
    </Content>

  )
}

function RolesCell( { value } ) {
  return (
    <div style={{ display : 'flex', flexDirection : 'column' }}>
      {value && value.map( ( role, index ) => (
        <span key={index} style={{ lineHeight : 'normal' }}>
          {role}
        </span>
      ) )}
    </div>
  )
}

export default DevicesUnderUserScreen
